import { motion } from 'framer-motion';

/**
 * HoverScale - Component with subtle scale animation on hover
 */
export const HoverScale = ({ 
  children, 
  scale = 1.02,
  className = '',
  transition = { duration: 0.2, ease: 'easeOut' }
}) => {
  return (
    <motion.div
      whileHover={{ scale }}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
};

/**
 * HoverLift - Component with lift effect on hover
 */
export const HoverLift = ({ 
  children, 
  y = -4,
  className = '',
  transition = { duration: 0.2, ease: 'easeOut' }
}) => {
  return (
    <motion.div
      whileHover={{ y }}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
};

/**
 * HoverGlow - Component with glow effect on hover
 */
export const HoverGlow = ({ 
  children, 
  className = '',
  glowColor = 'rgba(59, 130, 246, 0.3)'
}) => {
  return (
    <motion.div
      whileHover={{
        boxShadow: `0 10px 40px ${glowColor}`,
      }}
      transition={{ duration: 0.3 }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

